export const excludeNull = <T>(
  nullableArray: (T | null | undefined)[],
): T[] => {
  return nullableArray.filter((v): v is T => v !== null && v !== undefined);
};

export const unique = <T>(array: T[]): T[] => {
  return Array.from(new Set(array));
};

export const insertBetween = <T>(array: T[], separator: T): T[] => {
  return array.reduce<T[]>((acc, current, index, arr) => {
    acc.push(current);
    if (index < arr.length - 1) {
      acc.push(separator);
    }
    return acc;
  }, []);
};
